import { useEffect } from 'react';

export default function Toast({ message, type = 'success', onClose }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const bgColor = type === 'success' ? '#10b981' : '#ef4444';

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        minWidth: 300,
        maxWidth: 500,
        background: bgColor,
        color: '#fff',
        padding: '16px 20px',
        borderRadius: 'var(--radius-lg)',
        boxShadow: '0 10px 25px rgba(0,0,0,0.15), 0 4px 8px rgba(0,0,0,0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        zIndex: 9999,
        animation: 'slideInRight 0.3s ease-out',
      }}
    >
      <span style={{ fontSize: 14, lineHeight: 1.5, flex: 1 }}>
        {message}
      </span>
      <button
        onClick={onClose}
        style={{
          background: 'transparent',
          border: 'none',
          color: '#fff',
          fontSize: 20,
          lineHeight: 1,
          padding: 4,
          cursor: 'pointer',
          opacity: 0.8,
          flexShrink: 0,
        }}
        onMouseEnter={e => e.currentTarget.style.opacity = 1}
        onMouseLeave={e => e.currentTarget.style.opacity = 0.8}
      >
        ×
      </button>
    </div>
  );
}
